"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseHubClient = void 0;
const signalr_1 = require("@microsoft/signalr");
const signalREvent_1 = require("../../../contracts/enum/signalREvent");
class BaseHubClient {
    constructor(state) {
        var _a, _b;
        this._state = {
            url: '',
            hubPath: '',
        };
        this.isConnected = () => {
            return this._connection.state === signalr_1.HubConnectionState.Connected;
        };
        this.addListener = (channel, callBack) => {
            this.logMessage(`Listener created for: ${signalREvent_1.SignalRReceiveEvent[channel].toString()}`);
            this._connection.on(signalREvent_1.SignalRReceiveEvent[channel].toString(), (args) => callBack(args));
        };
        this.removeListener = (channel, callBack) => {
            this.logMessage(`Listener removed for: ${signalREvent_1.SignalRReceiveEvent[channel].toString()}`);
            this._connection.off(signalREvent_1.SignalRReceiveEvent[channel].toString(), (args) => callBack(args));
        };
        this.sendPayload = (channel, payload) => __awaiter(this, void 0, void 0, function* () {
            if (this.isConnected()) {
                try {
                    const channelString = signalREvent_1.SignalRSendEvent[channel].toString();
                    yield this._connection.send(channelString, payload);
                    this.logMessage('Message sent!', `channel: ${channelString}`, payload);
                }
                catch (e) {
                    console.error('sendPayload error', e);
                }
            }
            else {
                console.warn('No connection, cannot send payload!');
            }
        });
        this.logMessage = (message, ...optionalParams) => {
            console.log(message, optionalParams);
        };
        const apiUrl = (_a = state === null || state === void 0 ? void 0 : state.url) !== null && _a !== void 0 ? _a : 'https://api.assistantapps.com';
        this._state.url = apiUrl;
        this._state.hubPath = (_b = state === null || state === void 0 ? void 0 : state.hubPath) !== null && _b !== void 0 ? _b : '/hubs/OAuth';
        this._connection = new signalr_1.HubConnectionBuilder()
            .withUrl(`${this._state.url}${this._state.hubPath}`)
            .withAutomaticReconnect()
            .build();
        this._connection.start().then(() => this.logMessage('signalR connection'));
    }
}
exports.BaseHubClient = BaseHubClient;
